import { createContext, ReactNode, useContext, useState } from "react"
import * as Icons from '@/components/Icons'

export const useStepControl = () => {

  const [step, setStep] = useState(1)

  return {
    step,
    setStep
  }

}

const FormStepsContext = createContext<{ step: number }>({ step: 0 })

export function FormSteps({ controls, children }: { children: ReactNode, controls: ReturnType<typeof useStepControl> }) {

  return (
    <FormStepsContext.Provider value={{ step: controls.step }} >
      {children}
    </FormStepsContext.Provider>
  )

}

export function FormStepsHeader({ children }: { children: ReactNode[] }) {

  return (
    <div className="flex gap-x-4 gap-y-2 items-center py-6 flex-wrap min-w-0 w-full">
      {
        children.map((child, index) => {

          const isLast = index + 1 == children.length

          return (
            <div key={index} className="flex items-center gap-4">
              {child}
              {!isLast && <Icons.ChevronRight className="size-4 shrink-0" />}
            </div>
          )

        })

      }
    </div>
  )

}

FormSteps.Header = FormStepsHeader

export function FormStepsIndicator({ step: stepNumber, children }: { step: number, children: ReactNode }) {

  const { step } = useContext(FormStepsContext)

  const state = stepNumber <= step ? 'highlight' : 'default'

  return (
    <div
      className="flex items-center gap-2"
    >
      <div
        className="size-6 bg-primary bg-zinc-600 text-white dark:bg-zinc-400 dark:text-zinc-900 data-[state=highlight]:!bg-primary data-[state=highlight]:!text-white flex justify-center items-center rounded"
        data-state={state}
      >
        {stepNumber}
      </div>
      <span
        className="opacity-70 data-[state=highlight]:opacity-100 data-[state=highlight]:text-primary font-semibold"
        data-state={state}
      >
        {children}
      </span>
    </div>
  )

}

FormSteps.Indicator = FormStepsIndicator

export function FormStepsContent({ children, step: stepNumber }: { children: ReactNode, step: number, }) {

  const { step } = useContext(FormStepsContext)

  return (step == stepNumber) && children

}

FormSteps.Content = FormStepsContent

